import React from "react"
import autobind from "class-autobind"
import { Dialog, FlatButton } from "material-ui"
import strings from "../../../localization/strings"
import IVRNumberText from "./IVRNumberText"

interface IProps {
  edit: string
  hierarchyIPAddresses: string[]
  handleClose(): void
  handleAdd(ipAddress: string): void
  handleUpdate(payload: string): void
}
interface IState {
  phoneNumber: string
  error: boolean
}

export default class AddIVRNumberDialog extends React.Component<IProps, IState> {
  constructor(props) {
    super(props)
    this.state = {
      phoneNumber: props.edit ? props.edit : "",
      error: props.edit ? false : true
    }
    autobind(this)
  }

  async handleSave() {
    if (this.state.error) return
    this.props.edit ?
      this.props.handleUpdate(this.state.phoneNumber.replace(/\D/g, "").trim()) :
      this.props.handleAdd(this.state.phoneNumber.replace(/\D/g, "").trim())
  }

  render() {
    return (
      <Dialog
        open={true}
        title={this.props.edit ? "Edit Number" : "New Number"}
        titleStyle={{ paddingLeft: 35, paddingBottom: 10 }}
        actions={[
          <FlatButton
            label={strings.CANCEL}
            secondary={true}
            onClick={this.props.handleClose}
          />,
          <FlatButton
            label={strings.SAVE}
            primary={true}
            onClick={this.handleSave}
          />
        ]}
      >
        <hr />
        <div style={{ paddingRight: 20, paddingLeft: 20 }}>
          <div style={{ width: "100%" }}>
            <IVRNumberText
              phoneNumber={this.state.phoneNumber}
              existingNumbers={this.props.hierarchyIPAddresses.filter(item => this.props.edit ? item !== this.props.edit : true)}
              handleChange={(phoneNumber, error) =>
                this.setState({
                  phoneNumber,
                  error
                })
              }
            />
          </div>
        </div>
      </Dialog>
    )
  }
}